<template>
  <div>
    <a-modal
      title="Please select a customer profile"
      :visible="cdbSelectCustomerNum !== null"
      :maskClosable="false"
      @cancel="handleCdbSelectCancel"
      width="90%"
    >
      <a-form :form="cdbCodeForm" autocomplete="off">
        <a-row :gutter="10" v-if="false">
          <a-col :span="5">
            <a-form-item label="Last Name" :label-col="{ span: 10 }" :wrapper-col="{ span: 14 }">
              <a-input />
            </a-form-item>
          </a-col>
          <a-col :span="5">
            <a-form-item label="First Name" :label-col="{ span: 10 }" :wrapper-col="{ span: 14 }">
              <a-input />
            </a-form-item>
          </a-col>
          <a-col :span="4">
            <a-form-item label="Middle Name" :label-col="{ span: 14 }" :wrapper-col="{ span: 10 }">
              <a-input />
            </a-form-item>
          </a-col>
          <a-col :span="5">
            <a-form-item label="BirthDate" :label-col="{ span: 10 }" :wrapper-col="{ span: 14 }">
              <a-date-picker format="MM/DD/yyyy"/>
            </a-form-item>
          </a-col>
          <a-col :span="3">
            <a-form-item label="Gender" :label-col="{ span: 13 }" :wrapper-col="{ span: 11 }">
              <a-select>
                <a-select-option value="M">M</a-select-option>
                <a-select-option value="F">F</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="2">
            <div style="padding:4px 11px">
              <a-button type="primary" @click="cdbMatchSearch" :loading="cdbCodeConfirmloading">Match</a-button>
            </div>
          </a-col>
        </a-row>
      </a-form>
      <template slot="footer">
        <a-popconfirm
          title="Are you sure?"
          @confirm="handleCdbSelectConfirm"
          ok-text="Yes" 
          cancel-text="No"
        >
          <a-button type="primary">Confirm</a-button>
        </a-popconfirm>
      </template>
    </a-modal>
  </div>
</template>

<script>

export default {
  name: 'BookMatchSelectCustomerProfile',
  components: {
  },
  props: {
    cdbSelectCustomerNum: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      cdbCodeForm: this.$form.createForm(this),
      cdbCodeConfirmloading:false
    }
  },
  mounted () {
  },
  methods: {
    handleCdbSelectCancel () {
      this.$emit('cancel')
    },
    handleCdbSelectConfirm () {
       this.$emit('confirm')
    },
    handleSubmit (e) {
      e.preventDefault()
    },
    cdbMatchSearch () {

    }
  }
}
</script>
<style lang="less" scoped>

</style>